import { ActiveEnums } from "@app/data/engine.ts";
import { Checkbox, FormControlLabel, Tooltip, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";

interface Props {
    value: ActiveEnums;
    onChange: (value: ActiveEnums) => void;
    label?: string;
    size?: "small" | "medium" | "large";
    disabled?: boolean;
    activeText?: string;
    inactiveText?: string;
    indeterminateText?: string;
}

export default function AllYesNoCheckbox({
    value,
    onChange,
    label,
    size = "medium",
    disabled = false,
    activeText = "Yes",
    inactiveText = "No",
    indeterminateText = "All",
}: Props) {
    const isActive = value == ActiveEnums.ActiveOnly;
    const isIndeterminate = value == ActiveEnums.All;

    const theme = useTheme();

    const tooltipTitle = useMemo(() => {
        if (isIndeterminate) {
            return indeterminateText;
        }
        if (isActive) {
            return activeText;
        }
        return inactiveText;
    }, [isActive, isIndeterminate, indeterminateText, activeText, inactiveText]);

    const handleChange = () => {
        let newValue;
        if (value == ActiveEnums.NotActive) {
            newValue = ActiveEnums.ActiveOnly;
        } else if (value == ActiveEnums.ActiveOnly) {
            newValue = ActiveEnums.All;
        } else {
            newValue = ActiveEnums.NotActive;
        }
        onChange(newValue);
    };

    return (
        <FormControlLabel
            control={
                <Tooltip title={tooltipTitle}>
                    <Checkbox
                        checked={isActive}
                        indeterminate={isIndeterminate}
                        onChange={handleChange}
                        size={size}
                        disabled={disabled}
                    />
                </Tooltip>
            }
            label={<Typography color={disabled ? theme.palette.grey["500"] : undefined}>{label}</Typography>}
        />
    );
}
